import React, { useState, lazy, useEffect } from 'react';
import moment from 'moment';
import { UI_LOGBOOK_DATE } from 'globalconfig/constants/static';
import { mediaUrls } from 'globalconfig/constants/mediaUrls';
import SvgIcon from 'globalcomponents/SvgIcon/Base';
import Violations from '../Dashboard/Notfications';

const isEs = () => localStorage.getItem(window.$environment?.SERVICE_PROVIDER + 'Language') == 'es';
const layout = window?.$environment?.CURRENT_LAYOUT;
const Link = lazy(() => import(`globalcomponents/UI/Link`));
const Button = lazy(() => import(`globalcomponents/UI/Button/${layout}`));

const PdfNavigation = ({ list, currentIndex, setCurrentIndex, fetchLogBookView, date, i18n }) => (
  <div className="linkContainer pdfButtons">
    <div className="prev">
      <Link
        className="uppercase"
        onClick={() => {
          if (currentIndex < list.length - 1) {
            setCurrentIndex(currentIndex + 1);
            fetchLogBookView(list[currentIndex + 1]?.day || date);
          }
        }}
      >
        {isEs() ? <></> : <SvgIcon value={mediaUrls.arrowRight} />}
        {i18n.t('common.previous')}
      </Link>
    </div>
    <label className="dateLabel">{moment(list[currentIndex]?.day || date).format(UI_LOGBOOK_DATE)}</label>
    <div className="next">
      <Link
        className="uppercase"
        onClick={() => {
          if (currentIndex > 0) {
            setCurrentIndex(currentIndex - 1);
            fetchLogBookView(list[currentIndex - 1]?.day || date);
          }
        }}
      >
        {i18n.t('common.next')}
        {isEs() ? <></> : <SvgIcon value={mediaUrls.leftArrow} />}
      </Link>
    </div>
  </div>
);

const PdfViewer = ({ docLink, regeneratePdf, list, currentIndex, date, getDocumentToken, tokenPdfShow, i18n }) => (
  <div className="pdfWrap">
    <iframe src={docLink} width="100%" height="720px" id="logBookIframe" target="_parent"></iframe>
    <div id="regeneratePdf-wrapper">
      <Link
        id="regeneratePdf"
        onClick={() =>
          regeneratePdf({
            date: list[currentIndex - 1]?.day || date,
            callbackFuntion: () => {
              if (date && date.includes('-')) getDocumentToken({ apiId: 'getDocToken', callback: tokenPdfShow });
            },
          })
        }
      >
        {i18n.t('common.regeneratePdf')}
      </Link>
    </div>
  </div>
);

const EventContainer = ({ eventsData, updateShowEvents, getLogbookEvents, selectedDailyLog, i18n }) => (
  <>
    <Button
      label={eventsData?.showEvents ? i18n.t('common.viewLess') : i18n.t('common.viewMore')}
      onClick={() => {
        if (eventsData?.showEvents) {
          updateShowEvents(false);
        } else {
          if (Boolean(eventsData?.data?.engineEvents)) updateShowEvents(true);
          else getLogbookEvents(selectedDailyLog?.idPub || '');
        }
      }}
    />
    {eventsData?.showEvents && (
      <div className="events">
        <div className="eventContainer">
          <Violations potentialViolations={mapEvents(eventsData?.data?.engineEvents)} other heading={'Engine Events'} />
        </div>
        <div className="eventContainer">
          <Violations potentialViolations={mapEvents(eventsData?.data?.loginEvents)} other heading={'Login Events'} />
        </div>
      </div>
    )}
  </>
);

const mapEvents = (events) => events?.map((ele) => ({ label: ele.status, value: ele.start })) || [];

const PdfView = ({
  list,
  i18n,
  date,
  driver,
  documentToken,
  Styled,
  fetchLogBookView,
  getLogbookEvents,
  updateShowEvents,
  getDocumentToken,
  selectedDailyLog,
  regeneratePdf,
  eventsData,
}) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [docLink, setDocLiink] = useState('');

  const getIndex = () => {
    const formattedDate = date?.replace('/', '-');
    return list.findIndex((element) => element.day === formattedDate) || 0;
  };

  const tokenPdfShow = (type, data) => {
    const index = getIndex();
    setCurrentIndex(index);
    setDocLiink(
      `${window?.$environment?.BE_BASE_URL}/document/open/${selectedDailyLog?.document?.id}?token=${data}&output=embed`
    );
  };

  useEffect(() => {
    if (date && date.includes('-')) {
      getDocumentToken({ apiId: 'getDocToken', callback: tokenPdfShow });
    }
  }, [date, driver]);

  return (
    <Styled.PdfContainer>
      <div className="dailylogSection">
        <span className="dailyLogs">{i18n.t('Daily Log')}</span>
        <PdfNavigation
          list={list}
          currentIndex={currentIndex}
          setCurrentIndex={setCurrentIndex}
          fetchLogBookView={fetchLogBookView}
          date={date}
          i18n={i18n}
        />
      </div>
      <PdfViewer
        docLink={docLink}
        regeneratePdf={regeneratePdf}
        list={list}
        currentIndex={currentIndex}
        date={date}
        getDocumentToken={getDocumentToken}
        tokenPdfShow={tokenPdfShow}
        i18n={i18n}
      />
      <EventContainer
        eventsData={eventsData}
        updateShowEvents={updateShowEvents}
        getLogbookEvents={getLogbookEvents}
        selectedDailyLog={selectedDailyLog}
        i18n={i18n}
      />
    </Styled.PdfContainer>
  );
};

export default PdfView;
